import {BillSummaryApiDto} from "../../api/model/rest";

export default class BillSummary {

	constructor(public readonly id: string,
		public readonly referenceNumber: string,
		public readonly partnerName: string,
		public readonly total: number,
		public readonly due: number) {}

	static fromJson(json: BillSummaryApiDto): BillSummary {
		return new BillSummary(json.id, json.referenceNumber, json.partnerName, json.total, json.due);
	}
}
